import { LogLevel } from '@azure/msal-browser';
import logger from '../services/logger';
// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
const ua = window.navigator.userAgent;
const msie = ua.indexOf('MSIE ');
const msie11 = ua.indexOf('Trident/');
const msedge = ua.indexOf('Edge/');
const firefox = ua.indexOf('Firefox');
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ['User.Read'],
  prompt: "select_account"
};

// Config object to be passed to Msal on creation
export const getMsalConfig = (clientId, tenantId) => {
  logger.info('clientId::', clientId);
  logger.info('tenantId::', tenantId);
  return {
    auth: {
      clientId: clientId || '',
      authority: `https://login.microsoftonline.com/${tenantId || 'common'}`,
      redirectUri: '/msallogin',  // Update this to your app's redirect URI
    },
    cache: {
      cacheLocation: 'localStorage', // or 'sessionStorage'
      storeAuthStateInCookie: isIE || isEdge || isFirefox,  // For IE11 or Edge
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (!containsPii) {
            switch (level) {
              case LogLevel.Error:
                logger.error(message);
                break;
              case LogLevel.Info:
                logger.info(message);
                break;
              case LogLevel.Verbose:
                logger.debug(message);
                break;
              case LogLevel.Warning:
                logger.warn(message);
                break;
              default:
                logger.warn('DEFAULT');
                break;
            }
          }
        },
        logLevel: LogLevel.Verbose,
        piiLoggingEnabled: false,
      },
    },
  };

};